import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeRegisterData } from 'shell/models/practice-lists';
import { ItemVM } from 'shell/view-models/item';

interface TypeRegisterListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const TypeRegisterListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: TypeRegisterListProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<TypeRegisterData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-registro`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
        params: {
          sort: 'descrizioneRegistro:ASC',
        },
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeRegisterData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.tipoRegistro || '',
          value: item.descrizioneRegistro || '',
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="type-register-list-label">Registro</InputLabel>
      <PmiSelect
        labelId="type-register-list-label"
        id="type-register-list"
        name="type-register-list"
        value={value}
        label="Registro"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list.data as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeRegisterListComponent.displayName = 'type register list component';

const TypeRegisterList = memo(TypeRegisterListComponent);

export default TypeRegisterList as typeof TypeRegisterListComponent;
